import { render, staticRenderFns } from "./ClasificacionCompras.vue?vue&type=template&id=ff5a57ee"
import script from "./ClasificacionCompras.vue?vue&type=script&lang=js"
export * from "./ClasificacionCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports